import { factory, getResponseCamelization } from '@repo-level/core-front';
import type { CMSApiBase, CMSGroupParams, CMSImageBase } from './base';
import { buildCmsUrl, getResponseCMS } from './base';

export interface IFAQItem {
  id: number;
  question: string;
  answer: string;
}

export interface IFAQ extends CMSGroupParams {
  items: IFAQItem[];
}

export interface ITitle extends CMSGroupParams {
  text: string;
}

export interface IDescription extends CMSGroupParams {
  text: string;
}

export interface IStep {
  id: number;
  title: string;
  description: string;
  img: CMSImageBase;
  gradientHex?: string;
  secondRoundTitle?: string;
  secondRoundDescription?: string;
}

export interface IHowToParticipate extends CMSGroupParams {
  cards: IStep[];
}

export interface ICloverGoldLvlProgress {
  id: number;
  lvl: string;
  bg: CMSImageBase;
  character: CMSImageBase;
  characterCoin?: CMSImageBase;
}

export interface IPromoDate extends CMSGroupParams {
  id: number;
  startDate: string;
  endDate: string;
  secondRoundStartDate: string;
  secondRoundEndDate: string;
}

export interface ICloverGoldPromo extends CMSApiBase {
  title: string;
  faqTitle: string;
  howToParticipateTitle: string;
  titles: ITitle[];
  descriptions: IDescription[];
  faqs: IFAQ[];
  howToParticipate: IHowToParticipate[];
  lvlProgress: ICloverGoldLvlProgress[];
  promoDates: IPromoDate[];
  yourProgress: string;
  yourRewards: string;
}

export const getCloverGoldPromo = factory(
  (r) => (lang: string) =>
    r<ICloverGoldPromo>(
      'get',
      buildCmsUrl({
        path: 'clover-gold',
        lang,
        additionalParams: { populate: 'deep' },
      }),
      undefined,
      { transformResponse: [getResponseCamelization(), getResponseCMS] }
    )
);
